import React from 'react';

import { TextInput } from 'src/shared/components/form-elements/text-input';
import FormContext from 'src/shared/contexts/form-context';

type TextInputProps = {
    id: string;
    type?: 'text' | 'password' | 'number' | 'email' | 'tel';
    label?: React.ReactNode;
    placeholder: string;
    errorMessage?: React.ReactNode;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    name?: string;
};

export const FormInput = ({ id, ...props }: TextInputProps) => {
    const formMethods = React.useContext(FormContext);
    return (
        <TextInput
            id={id}
            data-testid={id}
            value={formMethods.values[id]}
            errorMessage={formMethods.errors[id]?.message}
            onChange={(e) => {
                formMethods.handleChange && formMethods.handleChange(e.target.value, id);
            }}
            {...props}
        />
    );
};
